import { HoverCard } from "common/hovercards/HoverCard";
import { ProfileImg } from "common/ProfileImg";
import { deserializeUser } from "lib/api/records";
import fetchJSON from "lib/fetchJSON";
import { Msg, privacyLevels } from "lib/localization";
import React, { Fragment } from "react";
import styles from "./UserCard.scss";

class User extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      privateUser: false,
    };
  }

  componentDidMount() {
    const { id } = this.props;

    fetchJSON(`/users/${id}.json`)
      .then((result) => {
        this.setState({ user: deserializeUser(result) });
      })
      .catch((r) => {
        this.setState({ privateUser: true });
      });
  }

  render() {
    const { name } = this.props;
    const { user, privateUser } = this.state;

    const locations = user && [user.locality, user.administrativeArea].filter((e) => !!e);

    return (
      <Fragment>
        {privateUser ? (
          <div className={styles.private}>
            <Msg m={privacyLevels.private} />
          </div>
        ) : (
          <>
            <div className={styles.profileImg}>
              <ProfileImg user={user} />
            </div>
            <div className={styles.UserContent}>
              <div className={styles.username}>{(user && user.name) || name}</div>
              <div className={styles.location}>{locations && locations.join(", ")}</div>
            </div>
          </>
        )}
      </Fragment>
    );
  }
}

export class UserCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasBeenHovered: false,
    };
  }

  onMouseEnter = () => {
    this.setState({ hasBeenHovered: true });
  };

  render() {
    const { hasBeenHovered } = this.state;
    const { children, ...props } = this.props;

    return (
      <span onMouseEnter={this.onMouseEnter}>
        {children}
        {hasBeenHovered && (
          <HoverCard className={styles.UserCard} target={this}>
            <User {...props} />
          </HoverCard>
        )}
      </span>
    );
  }
}
